var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({attrs:{"icon":""}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_c('Tooltip',{attrs:{"color":"primary","text":"Ver","top":""}},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("mdi-eye")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }